var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1795 65.2675C43.3451 67.3368 43.504 69.3233 43.5243 70.6494C45.1355 71.3297 48.9536 73.1234 51.0787 75.1457C47.203 75.5356 29.2037 75.0916 27.1257 74.7427C29.7882 73.1413 32.826 71.6814 35.7571 70.6802C35.7092 68.2898 35.8553 66.0368 36.0104 63.6468C36.133 61.758 36.2611 59.7835 36.3032 57.5882C36.01 57.5332 35.5258 57.4071 35.0466 57.2823C34.5982 57.1655 34.1542 57.0499 33.8753 56.9947C30.3944 56.3059 27.8581 54.3766 26.0255 51.871C23.5326 52.9674 20.4202 51.6511 18.3721 50.243C14.0732 47.2873 8.35268 41.3611 11.1591 35.6644C12.8341 32.2645 18.3446 31.1919 21.7242 31.0411C21.9118 29.4572 22.3343 27.9163 23.3172 26.8885C25.0992 25.025 28.164 24.2436 30.6149 23.8885C36.064 23.0989 41.6402 23.0263 47.0492 24.2869C47.1801 24.3172 47.3187 24.3489 47.4642 24.3821C49.8966 24.9381 54.2533 25.9339 56.9235 28.0523C57.5307 28.5774 58.0172 29.1802 58.3281 29.8762C58.6062 30.4986 58.7672 31.6975 58.7729 33.2601C59.2102 33.3792 59.6846 33.4974 60.1821 33.6214C63.435 34.432 67.677 35.489 69.015 38.6669C70.2856 41.6847 68.6746 44.5439 66.9095 46.9227C63.6097 51.3694 57.4035 57.0779 51.3344 54.0465C50.2655 55.0535 49.0618 55.8808 47.7111 56.4612C46.358 57.0427 44.6193 57.5172 42.803 57.7503C42.7102 59.4038 42.9511 62.4144 43.1795 65.2675ZM15.7254 35.2611C10.997 36.9158 14.2162 43.8318 16.9093 45.9636C17.7281 46.6117 18.5987 47.1983 19.4845 47.7495C20.5209 48.3944 22.8428 49.2595 24.1041 48.7809C23.4983 47.4059 23.0371 45.8827 22.6037 44.3696C21.7055 41.234 21.2986 37.7567 21.1713 34.4882C19.3353 34.4075 17.4699 34.6505 15.7254 35.2611ZM65.8915 42.207C63.8754 47.1765 59.1584 51.9542 53.3785 51.3858C55.913 46.924 58.4354 41.5684 59.0283 36.436C59.1827 36.4691 59.3385 36.4997 59.4947 36.5303C59.8661 36.6032 60.2394 36.6764 60.599 36.7858C62.9193 37.492 67.2469 38.866 65.8915 42.207Z",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4422 49.6367C41.8418 48.5842 36.2521 48.4019 31.7408 49.0168C29.8658 49.2724 27.8958 49.4179 26.1387 50.1947",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.869 46.228C51.2659 45.7343 49.6861 45.2334 48.0369 44.9094C41.5178 43.6289 35.0718 43.5023 28.5442 44.5315",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1909 11.8108C20.0013 13.4466 19.7712 15.1444 19.7385 16.7879L20.1909 11.8108Z",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1909 11.8108C20.0013 13.4466 19.7712 15.1444 19.7385 16.7879",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4058 17.8664C16.3372 17.8023 17.2726 17.816 18.2053 17.8474L15.4058 17.8664Z",
    fill: "#2E2E2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4058 17.8664C16.3372 17.8023 17.2726 17.816 18.2053 17.8474",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2439 17.7823C22.3097 17.9634 23.3397 17.9145 24.4119 17.9318L21.2439 17.7823Z",
    fill: "#2E2E2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2439 17.7823C22.3097 17.9634 23.3397 17.9145 24.4119 17.9318",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6059 23.0495C19.4187 22.0065 19.2302 20.5242 19.5022 19.4674L19.6059 23.0495Z",
    fill: "#2E2E2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6059 23.0495C19.4187 22.0065 19.2302 20.5242 19.5022 19.4674",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5976 59.0513C55.4347 59.9242 55.3604 60.8105 55.2793 61.6941L55.5976 59.0513Z",
    fill: "#2E2E2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5976 59.0513C55.4347 59.9242 55.3604 60.8105 55.2793 61.6941",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4712 62.824C52.9049 62.7764 53.3365 62.7292 53.7716 62.6981L52.4712 62.824Z",
    fill: "#2E2E2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4712 62.824C52.9049 62.7764 53.3365 62.7292 53.7716 62.6981",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1193 63.9175C55.0689 64.8671 55.096 65.8153 55.0662 66.7648L55.1193 63.9175Z",
    fill: "#2E2E2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1193 63.9175C55.0689 64.8671 55.096 65.8153 55.0662 66.7648",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2334 63.0681C56.9015 63.027 57.5733 62.9767 58.2427 62.9717L56.2334 63.0681Z",
    fill: "#2E2E2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2334 63.0681C56.9015 63.027 57.5733 62.9767 58.2427 62.9717",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8268 16.9662C55.51 14.3554 55.4549 12.3649 52.9363 11.0045C55.1361 10.4093 56.6513 7.603 57.0095 5.4635C57.403 7.50499 57.7243 9.88924 59.3499 11.3598C57.2893 12.2002 56.0722 14.5817 55.8272 16.6955",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7994 64.6449C25.6818 63.5682 25.4021 62.2981 24.2502 61.9287C25.2926 61.5053 25.8212 60.3621 25.9524 59.2935C25.9819 60.2021 26.2016 61.4175 27.1488 61.783C26.0885 62.2119 26.0439 63.652 25.7994 64.6449Z",
    fill: "#2E2E2E",
    stroke: "#F9F8F8",
    strokeWidth: 1.80328,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.7607fcea1835f2ab505199acf2fbe109.svg";
export { ForwardRef as ReactComponent };